import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DropdownSingleSelectWithoutSearch from "shared/components/inputs/dropdown/DropdownSingleSelectWithoutSearch";
import EmptyState from "shared/components/data-display/tables/EmptyState";
import GlobalConfig from "app/config/global";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import VStack from "shared/components/layout/stack/VStack";
import { getDropdownOptionsNoDefaultVal } from "shared/helper-functions/dropdown/dropdownHelpers";
import useSelectorRetainers from "features/projects/retainers-dashboard/useRetainersDashboard";
import { InputLabel, StyledEmptyState } from "./RetainersDashboardNav.styles";

const RetainersDashboardNav = ({ refreshButtonElement = null }) => {
    const { retainerId } = useParams();
    const [value, setValue] = useState(retainerId);
    const navigate = useNavigate();
    const projectsRetainersDashboardPath = GlobalConfig.routes.projectsRetainersDashboardLanding;

    const { selectorRetainers } = useSelectorRetainers();

    const handleOnChange = (id) => {
        setValue(id);
        navigate(`${projectsRetainersDashboardPath}/${id}`);
    };

    const retainerIdStored = JSON.parse(localStorage.getItem("storedRetainerId"));

    useEffect(() => {
        if (!selectorRetainers?.isLoading
            && selectorRetainers?.data?.length > 0
            && (!value || !retainerIdStored)) {

            navigate(`${projectsRetainersDashboardPath}/${selectorRetainers?.data[0].Id}`);
        }
    }, [selectorRetainers, value, retainerIdStored, navigate, projectsRetainersDashboardPath]);

    useEffect(() => {
        setValue(retainerIdStored);
    }, [retainerIdStored]);

    const retainerOptions = getDropdownOptionsNoDefaultVal(
        selectorRetainers?.data
    );

    if (selectorRetainers.isError) {
        return <>Error</>;
    }

    const selectorRetainersLength = selectorRetainers?.data?.length;

    return (
        <VStack>
            {selectorRetainersLength > 0 && !selectorRetainers.isLoading && (
                <HStack align="center">
                    <InputLabel>Retainers</InputLabel>
                    <DropdownSingleSelectWithoutSearch
                        className="dashboard-selector"
                        isSmallSize={true}
                        options={retainerOptions}
                        value={value}
                        onChange={handleOnChange}
                        disabled={
                            selectorRetainers.isLoading ||
                            retainerOptions.length === 0
                        }
                    />
                    {refreshButtonElement}
                </HStack>
            )}
            {selectorRetainersLength > 0
                ? !value && (
                    <EmptyState message="There are no content to show. Start by selecting retainer." />
                )
                : !selectorRetainers.isLoading && (
                    <StyledEmptyState message="You don't have any assigned retainer." />
                )}
        </VStack>
    );
};

RetainersDashboardNav.propTypes = {
    refreshButtonElement: PropTypes.node
};

export default RetainersDashboardNav;
